module.exports = __webpack_public_path__ + "572ed7fb44a7631afe97dd095a3d1601.png";